import React from 'react';

type PaginationItemProps = {
  active?: boolean;
  index: number;
  label: string | number;
  onSelect: (index: number) => void;
}

type PaginatorProps = {
  currentPage: number;
  padding?: number;
  perPage: number;
  total: number;
  onSelect: (index: number) => void;
}


function PaginationItem({ active, index, label, onSelect }: PaginationItemProps) {
  function handleClick(e) {
    e.preventDefault();
    onSelect(index);
  }

  return (
    <li className="page-item">
      <a className={`page-link ${active ? 'active' : ''}`} href="#" onClick={handleClick}>{label}</a>
    </li>
  );
}

export default function Paginator({ total, padding = 3, perPage, currentPage, onSelect }: PaginatorProps) {
  const pages = Math.ceil(total / perPage);

  const items: React.JSX.Element[] = [];

  if (currentPage > padding) {
    items.push(<PaginationItem index={1} key="first" label="« First" onSelect={onSelect} />);
  }

  if (currentPage > 1) {
    items.push(<PaginationItem index={currentPage - 1} key="prev" label="‹ Prev" onSelect={onSelect} />);
  }

  for (let i = (currentPage - padding + 1); i <= currentPage + padding; i++) {
    if (i < 1 || i > pages) continue;

    items.push(<PaginationItem active={i === currentPage} index={i} key={i} label={i} onSelect={onSelect} />);
  }

  if (currentPage < (pages - 1)) {
    items.push(<PaginationItem index={currentPage + 1} key="next" label="Next ›" onSelect={onSelect} />);
  }

  if (currentPage < (pages - padding)) {
    items.push(<PaginationItem index={pages} key="last" label="Last »" onSelect={onSelect} />);
  }

  return (
    <nav className="pagination-container w-auto">
      <ul className="pagination">
        {items}
      </ul>
    </nav>
  );
}
